module.exports = __webpack_public_path__ + "img/3.75f1407c.png";